import { lazy, Suspense } from "react";
import { ChevronDown } from "lucide-react";

// Lazy-load the dropdown content component to reduce initial bundle size
const LazyMoreDropdownContent = lazy(() => import("./MoreDropdownContent"));

interface MoreDropdownProps {
  moreItems: Array<{ route: string; label: string }>;
}

/**
 * MoreDropdown - Lazy-loaded dropdown menu for navigation overflow items
 * Only loads Radix UI dropdown components when actually needed
 */
export default function MoreDropdown({ moreItems }: MoreDropdownProps) {
  // Only show "More" dropdown if there are items to show
  if (moreItems.length === 0) {
    return null;
  }

  // Fallback button while loading (matches the actual button style)
  const fallbackButton = (
    <button
      className="font-sans font-normal text-[18px] min-[2200px]:text-[20px] tracking-[-0.18px] hover:opacity-80 transition-opacity flex items-center gap-1 outline-none whitespace-nowrap flex-shrink-0 relative pb-1"
      aria-label="More navigation options"
    >
      <span className="text-white">More</span>
      <ChevronDown className="w-4 h-4" />
    </button>
  );

  return (
    <Suspense fallback={fallbackButton}>
      <LazyMoreDropdownContent moreItems={moreItems} />
    </Suspense>
  );
}
